export function buildMultiArrayLabel(items, placeHolder) {
    if (!Array.isArray(items) || items.length === 0) {
        return placeHolder ?? "선택";
    }

    const first = items[0];
    const name = first?.name ?? first?.assetName ?? first?.title ?? "";
    const countUnit = first?.name ? "명" : "개";

    if (items.length === 1) {
        return name || (placeHolder ?? "선택");
    }

    return `${name} 외 ${items.length - 1}${countUnit}`;
}

export function getMultiDataIds(data) {
    if (!Array.isArray(data)) return [];
    return data.map((item) => item?.id).filter((id) => id != null);
}

export function resolveControlledMultiFlatNodes(selectedIds, listNodes, existingItems = []) {
    const listMap = new Map((listNodes ?? []).map((node) => [node.id, node]));
    const existingMap = new Map((existingItems ?? []).map((item) => [item.id, item]));

    return selectedIds
        .map((id) => listMap.get(id) ?? existingMap.get(id))
        .filter(Boolean);
}

export function getItemLabel(item) {
    return item?.name ?? item?.assetName ?? item?.title ?? "";
}

/** SearchSelectorPanelList 의 row meta(부서·직급, 그룹명, 사업자번호 등) — 검색 필터에도 사용 */
export function getItemMeta(item, entity) {
    if (entity === "userAccount") {
        const dept = item?.department?.name ?? "";
        const position = item?.position ?? "";
        return [dept, position].filter(Boolean).join(" ");
    }
    if (entity === "asset" || entity === "maintenance-assets") {
        return item?.group?.name ?? "";
    }
    if (entity === "company") {
        return item?.businessNumber ?? item?.code ?? "";
    }
    return "";
}
